import { useUiStore } from "@/store/uiStore";

export function PageLoader() {
  const pageLoading = useUiStore((s) => s.pageLoading);

  if (!pageLoading) return null;

  return (
    <>
      {/* Top progress bar */}
      <div className="fixed top-0 left-0 right-0 z-[100] h-1 overflow-hidden bg-bridge-accent/20">
        <div className="h-full w-2/5 bg-bridge-accent rounded-full animate-page-loader" />
      </div>
      {/* Dim + blur overlay — sits above page content and drawers (z-50) but
          below the progress bar, so the effect is consistent everywhere the
          loader is active. Blocks interaction while data is loading. */}
      <div className="fixed inset-0 z-[90] bg-white/50 backdrop-blur-[1px]" />
    </>
  );
}
